import React, { useCallback } from 'react';
import { InputAdornment, TextField, Typography } from '@mui/material';
import { fieldToTextField } from 'formik-mui';
import { ShebaFieldMask } from './sheba-field-mask';

export const ShebaField: React.FC<any> = (props): JSX.Element => {
    const {
        form: { setFieldValue },
        field: { name },
    } = props;

    const onChange = useCallback(
        (event: any) => {
            const value =
                'IR' +
                event.target.value.replaceAll(' ', '').replaceAll('_', '');
            setFieldValue(name, value ? value : '');
            props.onChange && props.onChange(event.target.value);
        },
        [setFieldValue, name, props],
    );

    return (
        <TextField
            {...fieldToTextField(props as any)}
            onChange={onChange}
            InputProps={{
                autoComplete: 'off',
                inputComponent: ShebaFieldMask as any,
                endAdornment: (
                    <InputAdornment position="end">
                        <Typography sx={{ color: 'inherit' }}>IR</Typography>
                    </InputAdornment>
                ),
            }}
            sx={{
                '.MuiInputBase-input': {
                    direction: 'rtl',
                    textAlign: 'right',
                },
            }}
            variant="outlined"
        />
    );
};
